export const LABELS = {
  // Login
  LOGIN: "Login",
  WELCOME_BACK: "Welcome Back",
  WELCOME: "Welcome",
  SING_IN_TO_AC_LINE: "Please Sign in to your account",
  SIGN_UP_AC_LINE: "Please complete the registration form to proceed.",
  // Sign In
  SIGN_IN: "Sign In",
  SIGN_UP: "Sign Up",
  EMAIL_ADDRESS: "Email Address",
  PASSWORD: "Password",
  REMEMBER_ME: "Remember me",
  EMAIL: "Email",
  REGISTER: "Register",

  // Forgot Password
  FORGOT_PASSWORD: "Forgot Password",
  CONTINUE: "Continue",
  RETURN_TO: "Return to",
  SING_IN_SMALL: "sign in",
  GET_OTP: "Get OTP",
  ENTER_REGISTER_EMAIL: "Please enter registered email address",

  // Constant Over image Lines
  PERSONAL_GUIDE: "Your smart guide to .",
  FERTILITY: "warehouse efficiency,",
  OVULATION: "inventory",
  AND: " and ",
  CYCLE_WELLNESS: " order fulfillment.",
  SMART_INSIGHTS_LINE:
    "Smarter warehouse management for faster, accurate, and cost-efficient logistics.",

  // Verify Otp
  OTP: "OTP",
  VERIFY_OTP: "Verify OTP",
  VERIFY_ACCOUNT: "Verify Account",
  VERIFICATION_CODE: "Verification Code",
  RESEND_OTP: "Resend OTP",
  VERIFY: "Verify",
  ENTER_VERIFICATION_CODE: "Enter Verification Code",
  OTP_SCREEN_LABEL: "OTP has been sent to your email address.",
  RESEND_OTP_IN: "Resend OTP In : ",
  SIX_DIGIT_OTP_REQUITED: "6 digits are required!",

  // Reset Password
  RESET_PASSWORD: "Reset Password",
  CHANGE_PASSWORD: "Change Password",
  OLD_PASSWORD: "Old Password",
  NEW_PASSWORD: "New Password",
  CONFIRM_PASSWORD: "Confirm Password",
  RESET_PASSWORD_LABEL: "Your new password must be different.",

  // Dashboard
  DASHBOARD: "Dashboard",

  // Change Password
  ENTER_CURRENT_PASSWORD: "Enter Current Password",
  ENTER_NEW_PASSWORD: "Enter New Password",
  ENTER_CONFIRM_PASSWORD: "Enter Confirm Password",

  // Counsellor Management
  COUNSELLOR_MANAGEMENT: "Counsellor Management",
  COUNSELLOR: "Counsellor",
  COUNSELLORS: "Counsellors",
  COUNSELLOR_TYPE: "Counsellor Type",
  TYPE: "Type",
  DRAG_DROP_HERE: "Drag and Drop here",
  OR: "Or",
  BROWSE_FILE: "Browse File",
  IMAGE: "Image",
  NO_FILE_CHOSEN: "No File Chosen",
  ADD: "Add",
  CREATE: "Create",
  DELETE: "Delete",
  EXPORT: "Export",
  CANCEL: "Cancel",
  UPDATE: "Update",
  SUBMIT: "Submit",
  SAVE: "Save",
  VIEW: "View",
  EDIT: "Edit",
  ADD_EDIT: "Add Edit",
  APPLY: "Apply",
  CLOSE: "Close",
  TIME: "Time",
  SCAN_BARCODE: "Scan Barcode",
  DROPDOWN_VALUE: "Dropdown Value",

  // Purchase Order
  PURCHASE_ORDER: "Purchase Order",
  PO_NO: "PO. NO.",
  ISSUE_DATE: "Issue Date",
  EXPECTED_DELIVERY_DATE: "Expected Delivery Date",
  LINKED_PROJECT: "Linked Project",
  VENDOR_NAME: "Vendor Name",
  SUPPLIER_NAME: "Supplier Name",
  VENDOR_ID: "Vendor Id",
  UNLOADING_START_AT: "Unloading Start At",
  UNLOADING_END_AT: "Unloading End At",
  DOCK_ASSIGNMENT: "Dock Assignment",
  SP_HANDLING_INSTRUCTIONS: "SP Handling Instructions",
  SELECT_DATE: "Selected Date",
  SELECT_DATE_TIME: "Selected Date Time",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  COST_CENTER: "Cost Center",
  ENTER_COST_CENTER: "Enter cost center",
  ASSIGN_PERSONAL: "Assign Personnel",
  ASSIGN_WP_TEAM: "Assign WP Team",
  ASSIGN_PERSONAL_REQUIRED: "Assign Personnel is required!",
  ASSIGN_WP_TEAM_REQUIRED: "Assign wp team is required!",
  ASSIGNED_DOCK_RECEIVING_AREA: "Assigned Dock Receiving Area",
  PURCHASE_ORDER_HISTORY: "Purchase Order History",
  HISTORY: "History",
  GRN: "GRN",
  GRN_LIST: "Preliminary GRN List",
  SERIAL_NUMBER: "Serial Number",
  ENTER_SERIAL_NUMBER: "Enter serial number",
  SERIAL_NUMBER_REQUIRED: "Serial number is required!",
  CONDITION: "Condition",
  ENTER_CONDITION: "Enter Condition",
  CONDITION_REQUIRED: "Condition is required!",
  DETAILS: "Details",
  ENTER_DETAILS: "Enter details",
  DETAILS_REQUIRED: "Details is required!",
  USER_DETAILS: "User Details",
  GRN_DETAILS: "GRN Details",
  GRN_ITEMS: "GRN Items",
  PENDING_QUANTITY: "Pending Qty",
  MODIFIED_QUANTITY: "Modified Qty",
  VENDOR_MODIFIED_QTY: "Vendor Modified Qty",
  PROJECT_OWNER_MODIFIED_QTY: "Project Owner Modified Qty",
  COLLECTED_QUANTITY: "Collected Qty",
  RECEIVED_QUANTITY: "Received Qty",
  RECEIVED_QUANTITY_REQUIRED: "Received qty is required!",
  MODIFIED_QUANTITY_REQUIRED: "Modified qty is required!",
  VENDOR_MODIFIED_QTY_REQUIRED: "Vendor Modified Qty is required!",
  PROJECT_OWNER_MODIFIED_QTY_REQUIRED: "Project Owner Modified Qty is required!",
  COLLECTED_QUANTITY_REQUIRED: "Collected qty is required!",
  MISSING_QUANTITY: "Missing Qty",
  MISSING_QUANTITY_REQUIRED: "Missing qty is required!",
  TOTAL_QUANTITY: "Total Qty",
  ENTER_PENDING_QUANTITY: "Enter pending qty",
  PENDING_QUANTITY_REQUIRED: "Pending qty is required!",
  APPROVED_QUANTITY: "Approved Qty",
  ENTER_APPROVED_QUANTITY: "Enter approved qty",
  APPROVED_QUANTITY_REQUIRED: "Approved qty is required!",
  REJECTED_QUANTITY: "Rejected Qty",
  ENTER_REJECTED_QUANTITY: "Enter rejected qty",
  REJECTED_QUANTITY_REQUIRED: "Rejected qty is required!",
  CURRENCY: "Currency",
  CURRENCY_REQUIRED: "Currency is required!",
  TESTING_DETAILS: "Testing Details",
  GRN_REFRENCE: "GRN Reference",

  // Inbound Management
  INBOUND_MANAGEMENT: "Inbound Management",
  GRN_MANAGEMENT: "Preliminary GRN Management",
  FINAL_GRN_MANAGEMENT: "Final GRN Management",
  INBOUND: "Inbound",

  // LRF
  EMAIL_REQUIRED: "Email address is required!",
  VALID_EMAIL: "Please enter a valid email address!",
  PASSWORD_REQUIRED: "Password is required!",
  OLD_PASSWORD_REQUIRED: "Old password is required!",
  OTP_REQUIRED: "OTP is required!",
  FOUR_DIGIT_OTP_REQUIRED: " 4 digits OTP is required!",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required!",
  PASSWORD_NOT_MATCH: "New password and confirm password do not match!",
  PO_NO_REQUIRED: "Purchase order number is required!",
  VENDOR_ID_REQUIRED: "Vendor id is required!",
  VENDOR_REQUIRED: "Vendor is required!",
  SUPPLIER_REQUIRED: "Supplier is required!",
  UNLOADING_START_AT_REQUIRED: "Unloading start at is required!",
  UNLOADING_END_AT_REQUIRED: "Unloading end at is required!",
  DOCK_ASSIGNMENT_REQUIRED: "Dock assignment is required!",
  SP_HANDLING_INSTRUCTIONS_REQUIRED: "SP handling instruction is required!",
  ISSUE_DATE_REQUIRED: "Issue date is required!",
  EXPECTED_DELIVERY_DATE_REQUIRED: "Expected delivery date is required!",
  LINKED_PROJECT_REQUIRED: "Linked project is required!",
  END_BEFORE_START:
    "Unloading end date at cannot be before unloading start date at",
  END_TIME_BEFORE_START_TIME: "Delivery end time cannot be before delivery start time",
  END_TIME: "End Time",
  START_TIME: "Start Time",

  // Setting Tab
  SLOT_DURATION_REQUIRED: "Slot duration is required!",
  START_TIME_REQUIRED: "Start time is required!",
  END_TIME_REQUIRED: "End time is required!",

  // Change Password
  CURRENT_PASSWORD_REQUIRED: "Current password is required!",
  NEW_PASSWORD_REQUIRED: "New password is required!",
  MIN_SIX_CHAR: "Minimum six character is required!",
  SPACE_NOT_ALLOWED: "Space not allowed!",
  PASSWORD_COMPLEXITY: "Password must be at least 8 characters and include uppercase, lowercase, numbers, and symbols",

  // Auth Placeholder
  ENTER_OTP: "Enter OTP",
  ENTER_EMAIL_ADDRESS: "Enter email address",
  ENTER_PASSWORD: "Enter password",

  // Profile
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  FIRST_NAME_REQUIRED: "First name is required!",
  LAST_NAME_REQUIRED: "Last name is required!",
  PHONE_NUMBER: "Phone Number",
  PHONE_NUMBER_REQUIRED: "Phone number is required!",
  ENTER_PHONE_NUMBER: "Enter phone number",
  ENTER_VALID_PHONE_NUMBER: "Enter valid phone number",
  //Role Management
  ROLE_MANAGEMENT: "Role Management",
  ACTIONS: "Actions",
  ROLE_NAME_REQUIRED: "Role name is required!",
  ROLE: "Role",

  // User Management
  USER_MANAGEMENT: "User Management",
  ROLE_NAME: "Role Name",
  APPROVAL_STATUS: "Approval Status",
  PROFILE_PICTURE: "Profile Picture",
  DEPARTMENT: "Entity",
  VERIFIED: "Verified",
  APPROVE: "Approve",
  APPROVED: "Approved",
  REJECT: "Reject",
  REJECTED: "Rejected",
  USER: "User",
  SUPPLIER: "Supplier",
  VENDOR: "Vendor",
  ALL: "All",
  DELETED_BY: "Deleted By",
  DELETED_AT: "Deleted At",
  COMPLETED: "Completed",
  PENDING: "Pending",
  DELIVERED: "Delivered",
  COLLECTED: "Collected",

  // Brand Management
  BRAND_MANAGEMENT: "Brand Management",
  SUPPLIER_MANAGEMENT: "Supplier Management",
  VENDOR_MANAGEMENT: "Vendor Management",
  ENTER_UNITOFMEASURE_NAME: "Enter unit of measure",
  WEIGHT_TYPE_MANAGEMENT: "Weight Type Management",

  // Unit Of measure
  UNITOFMEASURE_REQUIRED: "Unit of measure is required!",
  ENTER_UNITOFMEASURE: "Enter unit of measure",

  // Warehouse Management
  WAREHOUSE_MANAGEMENT: "Warehouse Management",
  NAME: "Name",
  ADDRESS: "Address",
  TOTAL_CAPACITY: "Total Capacity",
  ACTUAL_CAPACITY: "Actual Capacity",
  ACTUAL_CAPACITY_REQUIRED: "Actual capacity is required",
  TOTAL_WEIGHT: "Total Weight",
  TOTAL_WEIGHT_CAPACITY: "Total Weight Capacity",
  RACK_CAPACITY: "Rack Capacity",
  RACK_WEIGHT_CAPACITY: "Rack Weight Capacity",
  LAYOUT: "Layout",
  WAREHOUSE: "Warehouse",
  WAREHOUSE_NAME: "Warehouse Name",
  WAREHOUSE_CODE: "Warehouse Code",
  ENTER_WAREHOUSE_NAME: "Enter warehouse name",
  ENTER_WAREHOUSE_CODE: "Enter warehouse code",
  WAREHOUSE_NAME_REQUIRED: "Warehouse name required!",
  WAREHOUSE_CODE_REQUIRED: "Warehouse code required!",
  NAME_REQUIRED: "Name is required!",
  ADDRESS_REQUIRED: "Address is required!",
  LAYOUT_REQUIRED: "Layout is required!",
  TOTAL_CAPACITY_REQUIRED: "Total capacity is required!",
  TOTAL_WEIGHT_CAPACITY_REQUIRED: "Total weight capacity is required!",
  TOTAL_RACK_REQUIRED: "Total rack is required!",
  RACK_CAPACITY_REQUIRED: "Rack capacity is required!",
  RACK_WEIGHT_CAPACITY_REQUIRED: "Rack weight capacity is required!",
  CITY_REQUIRED: "City is required!",
  STATE_REQUIRED: "State is required!",
  REGION_REQUIRED: "Region is required!",
  CITY: "City",
  ENTER_CITY: "Enter City",
  STATE: "State",
  ENTER_STATE: "Enter State",
  REGION: "Region",
  ENTER_REGION: "Enter Region",
  CODE: "Code",
  ENTER_CODE: "Enter code",
  CODE_REQUIRED: "Code is required!",
  RACK_NO: "Rack No",
  ENTER_RACK_NO: "Enter rack no",
  RACK_NO_REQUIRED: "Rack number is required!",

  // Sign-up
  DEPARTMENT_NAME: "Entity Name",

  // Sign-up Error
  DEPARTMENT_REQUIRED: "Entity name is required!",
  ROLE_REQUIRED: "Role name is required!",

  // Counsellor Management
  IMAGE_REQUIRED: "Image is required!",

  NO_DATA_FOUND: "No Data Found",

  //ITEM_TYPE
  ITEM_TYPE_TEMPLATE: "Item Type Template",
  ITEM_TYPE: "Item Type",
  ITEM_TYPES: "Item Types",
  ITEM_TYPE_TEMPLATE_NAME: "Item Type Template Name",
  ITEM_TYPE_TEMPLATE_NAME_REQUIRED: "Item type template name is required!",
  ITEM_TYPE_TEMPLATE_REQUIRED: "Item type template is required!",
  ITEM_TYPE_REQUIRED: "Item Type is required!",
  STATUS: "Status",
  ALLOCATION_STATUS: "Allocation Status",
  STATUS_REQUIRED: "Status is required!",
  KEY: "Key",
  KEY_REQUIRED: "Key is required!",
  VALUE: "Value",
  VALUE_REQUIRED: "Value is required!",
  TEMPLATE_NAME: "Template Name",
  REQUIRED: "Required",
  DEFAULT_VALUE: "Default Value",
  ITEM_TYPE_TEMPLATE_FIELDS: "Item Type Template Fields",
  DIMENSION_FIELDS: "Dimension Fields",
  NO: "No.",
  FIELD_NAME: "Field Name",
  FIELD_NAME_REQUIRED: "Field name is required!",
  TEMPLATE: "Template",

  // Master Management
  MASTER_MANAGEMENT: "Master Management",

  // Item Type Management
  ITEM_TYPE_MANAGEMENT: "Item Type Management",

  UOM_MANAGEMENT: "UOM Management",
  DIMENSION_TYPE_MANAGEMENT: "Dimension Type Management",

  //CONDITION_MANAGEMENT
  CONDITION_MANAGEMENT: "Condition Management",
  CONDITION_NAME: "Condition Name",
  CONDITION_NAME_REQUIRED: "Condition Name is required!",
  ENTER_CONDITION_NAME: "Enter Condition Name",

  // Item Management
  ITEM_MANAGEMENT: "Items Management",
  PRINT_ITEMS: "Print Items",
  ITEMS: "Items",
  ITEM: "Item",
  ITEM_NAME: "Item Name",
  INVENTORY_CODE: "Inventory Code",
  ITEM_NO: "Item No.",
  UNIT_OF_MEASURE: "Unit Of Measure",
  UOM: "UOM",
  MEASURE_TYPE: "Measure Type",
  MEASURE_TYPE_REQUIRED: "Measure type is required!",
  RATING: "Rating",
  BRAND: "Brand",
  BRAND_NAME: "Brand Name",
  ENTER_BRAND_NAME: "Enter Brand Name",
  DATA_SHEET: "Date Sheet",
  TESTING_REQUIRED: "Testing Required",
  TESTING_WAREHOUSE: "Testing Warehouse",
  TESTING_WAREHOUSE_REQUIRED: "Testing Warehouse Required",
  TESTING_ZONE: "Testing Zone",
  TESTING_ZONE_REQUIRED: "Testing Zone Required",
  THIRD_PARTY_CERTIFICATION: "Third Party Certification",
  PHYSICAL_DIMENSIONS: "Physical Dimensions",
  DIMENSION_TYPE: "Dimension Type",
  WEIGHT: "Weight",
  USED_WEIGHT: "Used Weight",
  WEIGHT_TYPE: "Weight Type",
  ITEM_STATUS: "Item Status",
  STOCK_ALERT_QTY: "Stock Alert Qty",
  MIN_THRESHOLD: "Min Qty",
  MAX_THRESHOLD: "Max Qty",
  INTERNAL_ITEM: "Internal Item",
  OTHER_FIELDS: "Other Fields",
  UPDATE_STATUS: "Item status updated successfully",
  BARCODE: "Barcode ",
  MANUAL_ENTRY: "Manual Entry ",

  ITEM_NAME_REQUIRED: "Item name is required!",
  ITEM_REQUIRED: "Item is required!",
  UNIT_OF_MEASURE_REQUIRED: "Unit of measure is required!",
  RATING_REQUIRED: "Rating is required!",
  BRAND_REQUIRED: "Brand is required!",
  BRAND_NAME_REQUIRED: "Brand name is required!",
  CATEGORY_NAME_REQUIRED: "Category name is required!",
  DATA_SHEET_REQUIRED: "Data sheet is required!",
  WEIGHT_REQUIRED: "Weight is required!",
  WEIGHT_TYPE_REQUIRED: "Weight type is required!",
  DIMENSION_TYPE_REQUIRED: "Dimension type is required!",
  PHYSICAL_DIMENSIONS_REQUIRED: "Physical dimensions is required!",
  ITEM_STATUS_REQUIRED: "Item status is required!",
  STOCK_ALERT_QTY_REQUIRED: "Stock alert qty is required!",
  MIN_THRESHOLD_REQUIRED: "Min qty is required!",
  MAX_THRESHOLD_REQUIRED: "Max qty is required!",
  INTERNAL_ITEM_REQUIRED: "Internal item is required!",
  CLASSIFICATION_REQUIRED: "Internal item is required!",
  QUANTITY: "Qty",
  CONFIRM_QUANTITY: "Confirm Qty",
  SHIPMENT_ID: "Shipment Id",
  COUNTED_QUANTITY: "Counted Qty",
  DISCREPANCY: "Discrepancy",
  ENTER_DISCREPANCY: "Enter iscrepancy",
  DISCREPANCY_REQUIRED: "Discrepancy is required!",
  SYSTEM_QUANTITY: "System Qty",
  ENTER_COUNTED_QUANTITY: "Enter counted qty",
  QUANTITY_REQUIRED: "Qty is required!",
  CONFIRM_QUANTITY_REQUIRED: "Confirm qty is required!",
  SHIPMENT_ID_REQUIRED: "Shipment id is required!",
  COUNTED_QUANTITY_REQUIRED: "Counted qty is required!",
  COST_CENTER_REQUIRED: "Cost center is required!",
  PRICE: "Price",
  ENTER_PRICE: "Enter Price",
  PRICE_REQUIRED: "Price is required!",
  TOTAL: "Total",
  TOTAL_COST: "Total Price",
  TOTAL_ITEM_PRICE: "Total Item Price",

  REQUESTED_QUANTITY_REQUIRED: "Requested Qty is required!",

  SHELF_WIDTH: "Level Width",
  SHELF_LENGTH: "Level Length",
  SHELF_HEIGHT: "Level Height",
  SHELVES_PER_RACK: "Shelves Per Rack",
  NO_OF_RACKS: "No. Of Racks",
  COLUMNS_PER_RACK: "Columns Per Rack",
  LEVELS_PER_COULMNS: "Levels Per Columns",
  BIN_WIDTH: "Bin Width(m)",
  BIN_LENGTH: "Bin Length(m)",
  BIN_HEIGHT: "Bin Height(m)",
  BIN_WEIGHT: "Bin Weight(m)",
  BINS_PER_SHELF: "Bins Per Level",
  ZONE_CAPACITY: "Zone Capacity",
  ZONE_WEIGHT_CAPACITY: "Zone Weight Capacity",
  FILLING_FACTOR: "Filling Factor",

  ENTER_SHELF_WIDTH: "Enter level width",
  ENTER_SHELF_LENGTH: "Enter level length",
  ENTER_SHELF_HEIGHT: "Enter level height",
  ENTER_SHELVES_PER_RACK: "Enter shelves per rack",
  ENTER_NO_OF_RACKS: "Enter no. of racks",
  ENTER_COLUMNS_PER_RACK: "Enter columns per rack",
  ENTER_LEVELS_PER_COULMNS: "Enter levels per columns",
  ENTER_BIN_WIDTH: "Enter bin width",
  ENTER_BIN_LENGTH: "Enter bin length",
  ENTER_BIN_HEIGHT: "Enter bin height",
  ENTER_BINS_PER_SHELF: "Enter bins per level",
  ENTER_ZONE_CAPACITY: "Zone capacity",
  ENTER_ZONE_WEIGHT_CAPACITY: "Zone weight capacity",

  SHELF_WIDTH_REQUIRED: "Level width is required!",
  SHELF_LENGTH_REQUIRED: "Level length is required!",
  SHELF_HEIGHT_REQUIRED: "Level height is required!",
  SHELVES_PER_RACK_REQUIRED: "Shelves per rack is required!",
  NO_OF_RACKS_REQUIRED: "No. of rack is required!",
  COLUMNS_PER_RACK_REQUIRED: "Columns per rack is required!",
  LEVELS_PER_COULMNS_REQUIRED: "Levels per columns is required!",
  BIN_WIDTH_REQUIRED: "Bin width is required!",
  BIN_LENGTH_REQUIRED: "Bin length is required!",
  BIN_HEIGHT_REQUIRED: "Bin height is required!",
  BIN_WEIGHT_REQUIRED: "Bin weight is required!",
  BINS_PER_SHELF_REQUIRED: "Bins per level is required!",
  FILLING_FACTOR_REQUIRED: "Filling Factor is required!",

  LENGTH: "Depth",
  ENTER_LENGTH: "Enter Depth",
  LENGTH_REQUIRED: "Depth is required!",
  WIDTH: "Width",
  ENTER_WIDTH: "Enter Width",
  WIDTH_REQUIRED: "Width is required!",
  HEIGHT: "Height",
  ENTER_HEIGHT: "Enter Height",
  HEIGHT_REQUIRED: "Height is required!",
  TOTAL_VOLUME: "Approx. Unit Volume",
  DESCRIPTION: "Description",

  RESERVED_QUANTITY: "Reserved Qty",

  // Warehouse tagging location
  WAREHOUSE_TAGGING_LOCATION: "Warehouse Tagging Location",
  WAREHOUSE_ID: "Warehouse Id",
  LOCATION_CODE: "Location Code",
  LOCATION: "Location",
  DEFECTIVE_LOCATION: "Defective Location",
  LOCATIONS: "Locations",
  DEFECTIVE_LOCATIONS: "Defective Locations",
  TESTING_LOCATIONS: "Testing Locations",
  ENTER_LOCATION_CODE: "Enter location code",
  CAPACITY: "Capacity",
  USABLE_HEIGHT: "Usable Height",
  ENTER_CAPACITY: "Enter capacity",
  REMAINING_CAPACITY: "Remaining Capacity",
  EMPTY_BINS: "Empty Bins",
  USED_CAPACITY: "Used Capacity",
  WEIGHT_CAPACITY: "Weight Capacity",
  ZONES: "Zones",
  ZONE: "Zone",
  ZONE_CODE: "Zone Code",
  ENTER_ZONE_CODE: "Enter zone code",
  ZONE_CODE_REQUIRED: "Zone code is required!",

  ITEM_STORAGE: "Item Storage",
  ITEM_STORAGE_REQUIRED: "Item Storage is required!",

  REQUIRED_WAREHOUSE_ID: "Warehouse id is required!",
  TYPE_REQUIRED: "Type is required!",
  LOCATION_CODE_REQUIRED: "location code is required!",
  CONDUCTED_BY_REQUIRED: "Conducted by is required!",
  CAPACITY_REQUIRED: "Capacity is required!",

  // Cycle Count
  CYCLE_COUNT: "Cycle Count",
  CYCLE_COUNT_MANAGEMENT: "Cycle Count Management",
  CYCLE_STATUS: "Cycle Status",
  CYCLE_STATUS_REQUIRED: "Cycle Status is required!",
  ENTER_CYCLE_STATUS: "Enter cycle Status",
  ASSIGNED_STAFFS: "Assigned Staff",
  ASSIGNED_STAFFS_REQUIRED: "Assigned staff is required!",
  CONDUCTED_BY: "Conducted By",
  COMPLETE: "Complete",

  // Adjustment Management
  ADJUSTMENT_MANAGEMENT: "Adjustment Management",
  ADJUSTMENT: "Adjustment",
  REQUESTED_BY_NAME: "Requested By Name",
  REQUESTED_BY: "Requested By",
  APPROVED_BY_NAME: "Approved By Name",
  APPROVED_BY: "Approved By",
  REJECTED_BY: "Rejected By",
  ADJUSTMENT_APPROVED: "Adjustment Approved",
  ADJUSTMENT_TYPE: "Adjustment Type",
  ADJUSTMENT_TYPE_REQUIRED: "Adjustment type required!",
  CREATE_ADJUSTMENT: "Create Adjustment",

  // Inventory Management
  INVENTORY_MANAGEMENT: "Inventory Management",
  INVENTORY_MANAGEMENT_LOW_STOCK: "Inventory Management (Low Stock)",
  INVENTORY_LOG: "Inventory Log",
  INVENTORY: "Inventory",
  // Inventory Management
  VENDOR_INVENTORY_MANAGEMENT: "Vendor Inventory Management",
  VENDOR_INVENTORY: "Vendor Inventory",
  MY_INVENTORY: "My Inventory",

  // Item Transfer
  ITEM_TRANSFER_MANAGEMENT: "Transfer Order Management",
  ITEM_TRANSFER: "Transfer Order",
  SOURCE_WAREHOUSE_NAME: "Source Warehouse Name",
  SOURCE_WAREHOUSE: "Source Warehouse",
  SOURCE_TYPE: "Source Type",
  SOURCE_VENDOR_NAME: "Source Vendor Name",
  DESTINATION_WAREHOUSE_NAME: "Destination Warehouse Name",
  DESTINATION_WAREHOUSE: "Destination Warehouse",
  DESTINATION_TYPE: "Destination Type",
  DESTINATION_VENDOR_NAME: "Destination Vendor Name",
  RECEIVED_BY: "Received By",
  TRANFER_BY: "Transfer By",
  TRANSFER_STATUS: "Transfer Status",
  TRANSFER_ITEMS: "Transfer Items",
  SOURCE_WAREHOUSE_NAME_REQUIRED: "Source warehouse name is required!",
  SOURCE_TYPE_REQUIRED: "Source Type is required!",
  SOURCE_WAREHOUSE_REQUIRED: "Source warehouse is required!",
  SOURCE_VENDOR_NAME_REQUIRED: "Source vendor name is required!",
  DESTINATION_WAREHOUSE_NAME_REQUIRED:
    "Destination warehouse name is required!",
  DESTINATION_TYPE_REQUIRED: "Destination Type is required!",
  DESTINATION_WAREHOUSE_REQUIRED: "Destination warehouse is required!",
  DESTINATION_VENDOR_NAME_REQUIRED: "Destination vendor name is required!",
  RECEIVED_BY_REQUIRED: "Received by is required!",
  TRANFER_BY_REQUIRED: "Transfer by is required!",
  SOURCE_LOCATION: "Source Location",
  SOURCE_LOCATION_REQUIRED: "Source location is required!",
  DESTINATION_LOCATION: "Destination Location",
  DESTINATION_LOCATION_REQUIRED: "Destination location is required!",
  LOCATION_REQUIRED: "Location is required",
  TRANSFER_ITEM_REFERENCE: "Transfer Item Reference",

  // Trash
  TRASH: "Trash",
  AUDIT_LOG: "Audit Log",

  // CMS
  CMS: "CMS",
  TITLE: "Title",
  CONTENT_REQUIRED: "Content is required!",
  ENTER_CONTENT: "Enter Content",
  ENTER_TITLE: "Enter title",
  TITLE_REQUIRED: "Title is required!",
  CONTENT: "Content",

  // Track User Activities
  TRACK_USER_ACTIVITIES: "Track User Activities",
  MODULE: "Module",
  MESSAGE: "Message",

  // Status Manegement
  STATUS_MANAGEMENT: "Status Management",
  ENTER_VALUE: "Enter value",
  IS_DEFAULT: "Is Default",

  // Report Management
  REPORT_MANAGEMENT: "Report Management",
  REPORT: "Report",
  REPORT_REQUIRED: "Report is required!",
  DAY: "Day",
  DAY_REQUIRED: "Day is required!",
  ENTER_DAY: "Enter Day",
  TIME_REQUIRED: "Time is required!",
  RRPORT_REQUIRED: "Report is required!",
  SEND_TO: "Send To",
  SEND_TO_REQUIRED: "Send To is required!",

  // Project Management
  PROJECT_MANAGEMENT: "Project Management",
  PROJECT_NAME: "Project Name",
  ENTER_PROJECT_NAME: "Enter project name",
  PROJECT_NAME_REQUIRED: "Project name is required!",
  PROJECT_REQUIRED: "Project is required!",
  PROJECT: "Project",
  PROJECTS: "Projects",

  PROJECT_WALLET_MANAGEMENT: "Project Wallet",
  PROJECT_TRANSFER_REQUESTS: "Project Transfer Request",
  PROJECT_OWNER_NAME: "Project Owner",
  PROJECT_OWNER_NAME_REQUIRED: "Project owner is required!",
  DESTINATION_PROJECT_NAME: "Project Providing Items",
  SOURCE_PROJECT_NAME: "Project Requesting Items",
  SOURCE_PROJECT_NAME_REQUIRED: "Project Providing Items is required!",
  DESTINATION_PROJECT_NAME_REQUIRED: "Project Providing Items is required!",
  SOURCE_PROJECT: "Source project",
  DESTINATION_PROJECT: "Destination Project",
  SOURCE_PROJECT_REQUIRED: "Source project is required!",
  DESTINATION_PROJECT_REQUIRED: "Destination project is required!",

  // Dock Management
  DOCK_MANAGEMENT: "Dock Assignment",
  DOCK_NAME: "Dock Name",
  ENTER_DOCK_NAME: "Enter dock name",
  DOCK_NAME_REQUIRED: "Dock name is required!",
  DOCK: "Dock",
  ASSIGNED_DOCK: "Assigned Dock",
  JUSTIFICATION: "Justification",
  JUSTIFICATION_REQUIRED: "Justification is required!",
  ASSIGNED_DOCK_REQUIRED: "Assigned dock is required!",
  MAX_QUANTITY_IS: "Maximum allowed qty is ",

  // permission
  ROLE_Name: "Role Name",
  READ: "Read",

  // ZONE
  ZONE_MANAGEMENT: "Zone Management",

  // RACK
  RACK: "Rack",
  RACK_MANAGEMENT: "Rack Management",

  // COLUMN
  COLUMN: "Column",
  COLUMN_MANAGEMENT: "Column Management",

  // BIN
  BIN_MANAGEMENT: "Bin Management",
  BIN: "Bin",
  RACK_CODE: "Rack Code",
  ENTER_RACK_CODE: "Enter rack code",
  ENTER_COLUMN_CODE: "Enter Colum code",
  RACK_CODE_REQUIRED: "Rack code is required!",
  COLUMN_CODE_REQUIRED: "Column code is required!",
  SHELF_CODE: "Level Code",
  ENTER_SHELF_CODE: "Enter level code",
  SHELF_CODE_REQUIRED: "Level code is required!",
  BIN_CODE: "Bin Code",
  ENTER_BIN_CODE: "Enter bin code",
  BIN_CODE_REQUIRED: "Bin code is required!",
  COLUMN_CODE: "Column Code",

  // Shelf
  SHELF_MANAGEMENT: "Level Management",
  SHELF: "Level",

  // Work Oredr Type Management
  WORK_ORDER_TYPE_MANAGEMENT: "Work Order Category Management",
  WORK_ORDER_TYPE: "Work Order Category",
  WORK_ORDER_TYPE_REQUIRED: "Work order Category is required!",
  ENTER_WORK_ORDER_TYPE: "Enter work order Category",
  SHORT_CODE: "Short Code",
  ENTER_SHORT_CODE: "Enter short code",

  // Category Management
  CATEGORY: "Category",
  CATEGORY_REQUIRED: "Category is required!",
  CATEGORY_MANAGEMENT: "Category Management",
  CATEGORY_NAME: "Category Name",
  ENTER_CATEGORY_NAME: "Enter Category Name",

  // Category Management
  SUB_CATEGORY: "Subcategory",
  SUB_CATEGORY_REQUIRED: "Subcategory is required!",
  SUB_CATEGORY_MANAGEMENT: "Subcategory Management",
  SUB_CATEGORY_NAME: "Subcategory Name",
  ENTER_SUB_CATEGORY_NAME: "Enter Subcategory Name",

  // Work Order Mangement

  WORK_ORDER_MANAGEMENT: "Work Order Management",
  WORK_ORDER: "Work Order",
  WORK_ORDER_REQUEST: "Work Order Requests",
  MY_WORK_ORDERS: "My Work Order Requests",
  MY_WORK_ORDER: "My Work Order Request",
  WORK_ORDER_NUMBER: "Work Order Number",
  ENTER_WORK_ORDER_NUMBER: "Enter work order number",
  WORK_ORDER_NUMBER_REQUIRED: "Work order number is required!",
  REQUIRED_QUANTITY: "Required Qty",
  REQUIRED_QUANTITY_REQUIRED: "Required qty required!",
  WORK_ORDER_REQUIRED: "Work order is required!",

  // Collection Note
  COLLECTION_NOTE_MANAGEMENT: "Collection Notes",
  COLLECTION_NOTE_REQUEST: "Collection Note Requests",
  MY_COLLECTION_NOTE_REQUESTS: "Collection Note Requests",
  MY_COLLECTION_NOTE_REQUEST: "Collection Note Request",

  COLLECTION_NOTE: "Approved Collection Notes",
  COLLECTION_NOTE_NUMBER: "Collection Note Number",
  COLLECTION_NOTE_STATUS: "Collection Note Status",
  WORK_ORDER_STATUS: "Work Order Status",
  REQUESTOR_NAME: "Requestor Name",
  SCHEDULED_SLOT_START: "Collection Start Time",
  SCHEDULED_SLOT_START_REQUIRED: "Collection Start Time is required!",
  SCHEDULED_SLOT_END: "Collection End Time",
  SCHEDULED_SLOT_END_REQUIRED: "Collection End Time is required!",
  COLLECT: "Collect",
  COLLECTION_NOTE_INVOICE: "Collection Note Invoice",
  UPDATE_SERIAL_NUMBERS: "Update Serial Numbers",

  // Placeholders
  ENTER_FIELD_NAME: "Enter field name",
  ENTER_ITEM_TYPE_TEMPLATE_NAME: "Enter item type template name",
  ENTER_DEFAULT_VALUE: "Enter default value",
  ENTER_ROLE_NAME: "Enter role name",
  ENTER_NAME: "Enter name",
  ENTER_ADDRESS: "Enter address",
  ENTER_TOTAL_CAPACITY: "Total capacity",
  ENTER_TOTAL_WEIGHT_CAPACITY: "Total weight capacity",
  ENTER_RACK_CAPACITY: "Rack capacity",
  ENTER_LAYOUT: "Enter layout",
  ENTER_ITEM_NAME: "Enter item name",
  ENTER_WEIGHT_TYPE: "Enter weight type",
  ENTER_ITEM_TYPE: "Enter item type",
  ENTER_DIMENSION_TYPE: "Enter dimension type",
  ENTER_PO_NUMBER: "Enter purchase order number",
  ENTER_DOCK_ASSIGNMENT: "Enter dock assignment",
  ENTER_SP_HANDLING_INSTRUCTIONS: "Enter sp handling instructions",
  ENTER_QUANTITY: "Enter Qty",
  MODEL: 'Model',
  ENTER_REQUESTED_QUANITY: "Enter Requested Qty",

  // EXCHANGE
  BASE_CURRENCY: "Base Currency",
  EXCHANGE: "Exchange",
  UPDATED_AT: "Updated At",

  // Entity Management

  ENTITY_MANAGEMENT: "Entity Management",
  ENTITY: "Entity",
  ENTITIES: "Entities",
  ENTITY_NAME: "Entity Name",
  ENTITY_NAME_REQUIRED: "Entity name is required!",
  ENTER_ENTITY_NAME: "Enter entity name",
  ENTITY_REQUIRED: "Entity is required!",

  SIGNED_GRN: "Vendor Delivery Note",
  DOWNLOAD_SIGNED_GRN: "Download Vendor Delivery Note",
  MISSING_QUANTITIES: "Missing Qty",
  REJECTED_QUANTITIES: "Rejected Qty",
  DELIVERY_PENDING: "Qty Pending",
  QUANTITY_PENDING_TO_SHIPPED: "Pending Shipment Qty",
  QUANTITY_DELIVERED: "Delivered Qty ",
  SHIPPED_QUANTITY: "Shipped Qty",
  SHIPPED_QUANTITY_REQUIRED: "Shipped Qty is required!",
  ITEM_QUANTITY_DETAILS: "Item Qty Details",
  CALCULATED_QTY: "Calculated Qty",

  UPLOAD: "Upload",
  INBOUND_HISTORY: "Inbound History",
  ITEM_INBOUND_HISTORY: "Item Inbound History",
  WORK_ORDER_REQUEST_NUMBER: "Request No.",
  WORK_ORDER_REQUEST_NUMBER_REQUIRED: "Request No. is required!",
  SCHEDULER: "Scheduler",
  DOWNLOAD_EXPORT: "Download & Export",
  PREVIEW: "Preview",
  RESET: "Reset",
  NO_DATA_AVAILABLE: "No Data Available",

  ITEM_TRANSFER_DETAILS: "Item Transfer Details",
  CREATED_BY: "Created By",
  CREATED_AT: "Created At",
  TO_NO: "TO. NO.",

  UNIT_PRICE: "Unit Price",
  UNIT_PRICE_REQUIRED: "Unit price is required",
  ENTER_UNIT_PRICE: "Enter Unit Price",
  REASON: "Reason",
  SELECTED: "Selected",
  GRN_OPTIONAL_DETAILS: "GRN Optional Details",
  GRN_ITEM_QUANTITY_REQUIRED_DETAILS: "GRN Item Qty Required Details",
  PO_SUMMARY: "PO Summary",
  ITEM_MEASUREMENT_INFORMATION: "Item Measurement Information",
  PO_STATUS: "PO Status",
  NOTIFICATIONS: "Notifications",
  SELECT_TESTED_SERIALS: "Select Tested Serial Numbers",
  SEARCH_SERIAL_NUMBER: "Search Serial Numbers",
  NO_SERIALS: "Serial Number Not Available",
  ADD_TESTED_SERIAL_NUMBER: "Add Tested Serial Number",

  LEVELS: "Levels",
  LEVEL: "Level",
  AVAILABLE_QUANTITY: "Available Qty",
  AVAILABLE_QUANTITY_REQUIRED: "Available qty is required",
  PREV: "Prev",
  NEXT: "Next",
  WEEK: "Week",
  STORING_LEVEL: "Storing Level",
  PLEASE_SELECT_FROM: "Please select from",
  TRANSFER_QTY: "Transfer Qty",
  TRANSFER_QTY_REQUIRED: "Transfer Qty is Required",
  SOURCE_DETAILS: "Source Details",
  DESTINATION_DETAILS: "Destination Details",
  QTY_COLLECT: "Qty To Collect",
  QTY_COLLECT_REQUIRED: "Qty to collect is required",
  REQUESTED_QTY: "Requested Work Order Qty",
  REQUESTED_QTY_REQUIRED: "Requested work order qty is required",
  NOTIFICATIONS_SETTINGS: "Notifications Settings",
  NOTIFICATIONS_LIST: "Notifications List",
  VIEW_ALL: "View All",

  LATITUDE: "Latitude",
  ENTER_LAT: "Enter latitude",
  LAT_REQUIRED: "Latitude is required!",
  LONGITUDE: "Longitude",
  ENTER_LONG: "Enter longitude",
  LONG_REQUIRED: "Longitude is required!",

  IQD: "IQD",
  MARK_ALL_READ: "Mark All As Read",
  GPS_LOCATION: "GPS Location",
  WO_TYPE: "Work Order Request Type",
  WO_TYPE_REQUIRED: "Work order request type is required",
  CO_TYPE: "Collection Note Type",
  CO_TYPE_REQUIRED: "Collection note type is required",
  HELP: "Help",
  CREATE_INBOUND: "Create Inbound",
  COMPANY_NAME: "Company Name",
  COMPANY_NAME_REQUIRED: "Company name is required!",
  SELECT_DEFECTIVE_SERIALS: "Select Defected Serial Numbers",
  ADD_DEFECTED_SERIAL_NUMBER: "Add Defected Serial Numbers",
  TEMPORARY_STORAGE: "Temporary Storage",
  TEMP_STORAGE_QTY: "Temp Storage Qty",
  ENTER_TEMP_STORAGE_QTY: "Enter temp storage qty",
  WAREHOUSE_SUPERVISOR: "Warehouse supervisor",
  WAREHOUSE_SUPERVISOR_REQUIRED: "Warehouse supervisor is required!",
  EXPECTED_READY_TIME: "Expected Ready Time",
  EXPECTED_READY_TIME_REQUIRED: "Expected ready time is required!",
  START_PREPARING: "Start Preparing",
  RE_PREPARE: "Re-Prepare",
  SELECT_ITEMS: "Select Items",
  PREPARED: "Prepared",
  READYFORCOLLECTION: "Ready For Collection",
  REQUEST_FOR_PICKUP: "Request For Pickup",
  SCHEDULED_FOR_PICKUP: "Schedule For Pickup",
  REASON_REQUIRED: "Reason is required!",
  DISPATCHER_SUPERVISOR: "Dispatcher Supervisor",
  DISPATCHER_SUPERVISOR_REQUIRED: "Dispatcher supervisor is required!",
  START_COLLECTION: "Start Collection",
  DISPATCHED: "Dispatch",
  RECEIVED: "Received",
  SERIALS: "Serials",
  ASSEMBLE_ITEM_MANAGEMENT: "Assembled Item Management",
  ASSEMBLE_ITEM_TYPE_LIST: "Assembled Item Type List",
  ASSEMBLE_ITEM_REQUEST_LIST: "Assembled Items Request",
  NEW_REQUESTED_QTY: "Requested Qty",
  ITEM_REQUESTED_QTY: "Item Requested Qty",
  ACCEPT: "Accept",
  ASSEMBLE: "To Be Assembled",
  MARK_READY: "Mark as Assembled ",
  MARK_ASSEMBLED: "Mark As Assembled",
  STORED: "Store",
  ASSEMBLED_ITEMS: "Assembled Item Type",
  ASSEMBLED_ITEM_NO: "Assembled Item No",
  MAIN_ITEM: "Main Item",
  ITEM_DETAILS: "Item Details",
  QTY_STORED: "Qty to store",
  QTY_STORED_REQUIRED: "Qty to store is required!",
  UPLOAD_FILE: "Upload File",
  FILE: "File",
  INVENTORY_QUANTITY_PREVIOUS_WEEK: "Inventory Quantity (Previous Week)",
  COLLECTED_QUANTITY_CURRENT_WEEK: "Collected Quantity (Current Week)",
  HELP_MANAGEMENT: "Help Management",
  DASHBOARD_SECTIONS: "Dashboard Ordering Management",
  DASHBOARD_CATEGORY_MANAGEMENT: "Dashboard Category Management",
  VENDOR_DASHBOARD_CATEGORY_MANAGEMENT: "Vendor Dashboard Category",
  ITEM_ORDERING_MANAGEMENT: "Item Ordering Management",
  HELP_CATEGORY: "Help Category Management",
  HELP_VIDEO: "Help Video Management",
  ASSIGNED_DELIVERY_DETAILS: "Assigned Delivery Details",
  ACTUAL_RECEIVED_QTY: "Actual Received Qty",
  ACTUAL_RECEIVED_QTY_REQUIRED: "Actual Received Qty is required!",
  REQUEST_ITEMS: "Request Collection Note",
  CURRENT_QTY: "Current Qty",
  SET_VALUE_IN_NAME: "Set Value In Item Name",
  ITEM_NAME_SEPERATION_BY: "Item Name Seperation By",
  SEND_REMINDER: 'Send Reminder',
  RECEIVED_ITEMS: 'Receive Items',
  REQUIRED_QTY_PER_ASSEMBLED_ITEM: 'Required Qty Per Assembled Item',
  WORK_ORDER_CALCULATED_QTY: "Work Order Calculated Qty",
  QTY_ORDERED: 'Ordered Qty',
  REQUESTED_QTY1: 'Requested Qty',
  PROJECTS_AVAILABLE_QUANTITY: "Project's Available Qty",

  STOCK_ALERT: "Stock Alert Minimum Qty",
  TOTAL_VOLUME_REQUIRED: "Approx. Unit Volume is required!",
  SELECT_SERIAL_NUMBER: "Select Serial Number",
  CURRENT_WEEK_QTY: "Current Week Qty",
  CURRENT_WEEK_QTY_REQUIRED: "Current week qty is required!",
  WEAK: "Weak",
  MEDIUM: "Medium",
  STRONG: "Strong",
  VERY_GOOD: "Very Good",
  REPREPARATION_REASON: "Re-Preparation Reason",
  REPREPARATION_REASON_REQUIRED: "Re-Preparation reason is required!",
  ARE_YOU_SURE_YOU_WANT_TO_REQUEST_REPREPARATION_FOR_THIS_COLLECTION_NOTE: "Are you sure you want to request re-preparation for this collection note?",
  RE_PREPARE_CONFIRMATION: "Re-prepare Confirmation",

  SOURCE_SUPERVISOR: "Source Supervisor",
  SOURCE_SUPERVISOR_REQUIRED: "Source Supervisor is required!",
  DESTINATION_SUPERVISOR: "Destination Supervisor",
  DESTINATION_SUPERVISOR_REQUIRED: "Destination Supervisor is required!",

  RESOLUTION_TYPE: "Resolution Type",
  RESOLUTION_TYPE_REQUIRED: "Resolution Type is required!",
  COMMENTS: 'Comment',
  DELIVERY_DATE: 'Delivery Date',
  DATE_TIME: "Date & Time",
  SWAPPED_ITEMS: 'Swapped Items',
  SWAPPED_BY: 'Swapped By',
  SWAPPED_AT: 'Swapped At',
  CLOSED_DATE_TIME: "Closed Date & Time",

  TRUCK_CAPACITY_MANAGEMENT: "Truck Capacity Management",
  TRUCK_TYPE: "Truck Type",
  INTERNAL_WIDTH: "Internal Width",
  INTERNAL_LENGTH: "Internal Length",
  INTERNAL_HEIGHT: "Internal Height",
  TOTAL_VOLUME_CAPACITY: "Total Volume Capacity",
  TRUCK_MIN_THRESHOLD: "Min Threshold",
  TRUCK_MAX_THRESHOLD: "Max Threshold",
  MAX_WEIGHT_CAPACITY: "Max Weight Capacity",
  USABLE_WEIGHT_CAPACITY: "Usable Weight Capacity",
  ENTER_TRUCK_TYPE: "Enter Truck Type",
  ENTER_INTERNAL_WIDTH: "Enter Internal Width",
  ENTER_INTERNAL_LENGTH: "Enter Internal Length",
  ENTER_INTERNAL_HEIGHT: "Enter Internal Height",
  ENTER_TOTAL_VOLUME_CAPACITY: "Enter Total Volume Capacity",
  ENTER_MIN_THRESHOLD: "Enter Min Threshold",
  ENTER_MAX_THRESHOLD: "Enter Max Threshold",
  ENTER_MAX_WEIGHT_CAPACITY: "Enter Max Weight Capacity",
  TRUCK_TYPE_REQUIRED: "Truck Type is required!",
  INTERNAL_WIDTH_REQUIRED: "Internal Width is required!",
  INTERNAL_LENGTH_REQUIRED: "Internal Length is required!",
  INTERNAL_HEIGHT_REQUIRED: "Internal Height is required!",
  TOTAL_VOLUME_CAPACITY_REQUIRED: "Total Volume Capacity is required!",
  TRUCK_MIN_THRESHOLD_REQUIRED: "Min Threshold is required!",
  TRUCK_MAX_THRESHOLD_REQUIRED: "Max Threshold is required!",
  MAX_WEIGHT_CAPACITY_REQUIRED: "Max Weight Capacity is required!",
  MIN_THRESHOLD_RANGE: "Min Threshold must be between 0 and 100!",
  MAX_THRESHOLD_RANGE: "Max Threshold must be between 0 and 100!",
  THRESHOLD_CROSS_ERROR: "Max Threshold cannot be less than Min Threshold!",
  ALLOCATE_TRUCKS: "Allocate Trucks",
  SUMMARY: "Summary",
  COUNT: "Allocated Trucks",
  VOLUME_USED: "Volume Used",
  UTILIZATION_PERCENT: "Utilization Percent",
  TRUCK_ALLOCATIONS: "Truck Allocations",
  VOLUME: 'Volume',
  NOTE: 'Note',
  BACK: 'Back',
  ITEM_TYPE_IDS: ['edcc396d-0f3f-43d0-9114-8b71ac4eb7dd', '66e00ee8-d0ee-4084-9bb3-ccc2fb25c039']
};

